<template>
  <div>
    <div class="border-b border-gray-200">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <a
          v-for="tab in tabs"
          @click="$emit('changed', tab.id)"
          :key="tab.name"
          href="#"
          :class="[
            current == tab.id
              ? 'won-border-color-green won-blue'
              : 'border-transparent won-settings-gray hover:text-gray-500 hover:border-gray-300',
            small ? '!text-sm !py-1' : '',
            'whitespace-nowrap py-2 px-1 border-b-4 font-medium text-base',
          ]"
          :aria-current="current == tab.id ? 'page' : undefined"
        >
          {{ tab.name }}
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    current: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
